module.exports = __webpack_public_path__ + "static/media/default-avatar.e9e8dad7.jpg";